import { registerBlockType } from '@wordpress/blocks';
import { __ } from '@wordpress/i18n';
import Trends from 'Edits/Trends';

registerBlockType('eformv4/trends', {
	title: __('Embed Form Reports (trends) - eForm', 'ipt_fsqm'),
	icon: 'chart-area',
	category: 'eform-v4',
	attributes: {
		form_id: {
			type: 'string',
			default: '',
		},
		load: {
			type: 'string',
			default: '1',
		},
		title: {
			type: 'string',
			default: __('Trends', 'ipt_fsqm'),
		},
		types: {
			type: 'object',
			default: {
				mcq: true,
				pinfo: true,
				freetype: true,
			},
		},
		mcq_ids: {
			type: ['array', 'string'],
			default: 'all',
		},
		mcq_config: {
			type: 'object',
			default: {},
		},
		freetype_ids: {
			type: ['array', 'string'],
			default: 'all',
		},
		pinfo_ids: {
			type: ['array', 'string'],
			default: 'all',
		},
		pinfo_config: {
			type: 'object',
			default: {},
		},
		filters: {
			type: 'object',
			default: {
				users: 'all', // available users
				urlTracks: 'all', // available urlTracks
				mk: '', // User metakey
				mv: '', // User Meta value
				smin: '', // Min score
				smax: '', // Max score
				dtmin: '', // Date min
				dtmax: '', // Date max
			},
		},
		data: {
			type: 'object',
			default: {
				data: true,
				others: true,
				names: true,
				date: true,
			},
		},
		appearance: {
			type: 'object',
			default: {
				block: true,
				heading: true,
				description: true,
				header: true,
				border: true,
				material: true,
				print: false,
			},
		},
	},

	edit({ attributes, className, setAttributes }) {
		return <Trends {...{ attributes, className, setAttributes }} />;
	},

	save() {
		return null;
	},
});
